<template>
  <div class="main" style="margin: 0">
    <dados-proposta :active="3" />
    <main class="container alianca-content alianca-content-seuplano" style="margin: 0 auto!important">
      <section class="row">
        <div class="main-content main-content-seuplano col-12">
          <div id="pagamento">

            <loading
            :active.sync="isLoading" 
            :can-cancel="false" 
            :is-full-page="true"
            class="overlay-load">
          </loading>

          <transition name="fade">
            <div id="step-1" class="multi-step-form active-step" v-if="etapa==='step-9'">
              <div class="d-flex align-content-center btn-back-pagamento">
                <p><img
                  src="../assets/arrow-left.svg"
                  alt="Voltar etapa"
                  @click.prevent="backtodps()"
                  /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px">
                  <h3>Forma de pagamento</h3>
                </div>
                <div class="row itens-pagamento" style="margin-top: 55px">
                  <b-col sm="12" :md="colsystem" style="margin-left: -25px;" v-if="exibedebito" class="child-pagamento">
                    <b-button :class="{ 'btn-clicked-dps': opcaoescolhida == 1 }" class="btn-opcoes-pagamento" @click="showformconta(1)">
                      <img
                      v-if="opcaoescolhida == 1"
                      src="../assets/debitoconta-select.svg"
                      alt="Debito em conta"
                      />
                      <img
                      v-else
                      src="../assets/debitoconta.svg"
                      alt="Debito em conta"
                      />
                      Débito em conta
                    </b-button>
                    <small class="small-pagamento"><b-icon icon="exclamation-circle" style="margin-right: 5px"></b-icon> Ao escolher Débito em conta, você precisará autorizar a transação por email. Você receberá um Token (senha) e deverá informar de imediato.</small>
                  </b-col>

                  <b-col sm="12" :md="colsystem" v-if="exibeconsignacao" class="child-pagamento">
                    <b-button :class="{ 'btn-clicked-dps': opcaoescolhida == 2 }" class="btn-opcoes-pagamento" @click="showformconta(2)">
                      <img
                      v-if="opcaoescolhida == 2"
                      src="../assets/consignacao-select.svg"
                      alt="Consignação em folha"
                      />
                      <img
                      v-else
                      src="../assets/consignacao.svg"
                      alt="Consignação em folha"
                      />
                      Consignação em folha
                    </b-button>
                    <small class="small-pagamento"><b-icon icon="exclamation-circle" style="margin-right: 5px"></b-icon> Consignação é o desconto realizado na folha de pagamento para oferecer produtos com melhores condições e facilidades ao servidor.</small>
                  </b-col>

                  <b-col sm="12" :md="colsystem" v-if="exibeboleto" class="child-pagamento">
                    <b-button :class="{ 'btn-clicked-dps': opcaoescolhida == 3 }" class="btn-opcoes-pagamento" @click="opcaoescolhida = 3; showformconta(3)">
                      <img
                      v-if="opcaoescolhida == 3"
                      src="../assets/boleto-select.svg"
                      alt="Boleto Bancário"
                      />
                      <img
                      v-else
                      src="../assets/boleto.svg"
                      alt="Boleto Bancário"
                      />
                      Boleto Bancário
                    </b-button>
                    <small class="small-pagamento"><b-icon icon="exclamation-circle" style="margin-right: 5px"></b-icon> Ao escolher boleto bancário você poderá pagar em qualquer instituição ou estabelecimento conveniado até a data de vencimento indicada.</small>
                  </b-col>

                </div>
              </div>
            </transition>

            <transition name="fade">
              <div id="conta-form" class="multi-step-form active-step top-border-pagamento" style="display: none">
                <div v-if="opcaoescolhida==2" id="form-infoorgao" class="row pagamento-entidade">
                  <div class="form-row form-pagamento">
                    <div class="form-group col-md-12">
                      <p>Unidade de pagamento:</p>
                      <autocomplete
                      :source="options_unidadepagadora"
                      :showNoResults="false"
                      placeholder="Digite ou selecione aqui a sua Unidade"
                      inputClass="form-control"
                      :initialValue="null"
                      resultsValue="name"
                      @selected="el => unidadepagadora = el.selectedObject.value"
                      :class="{
                        'statusok-fontbold-autocomplete': unidadepagadora != 'null',
                      }"
                      :style="[
                      unidadepagadora != 'null'
                      ? {
                        background:
                        'url(' +
                        require('@/assets/statusok.svg') +
                        ') no-repeat right 2.6% center #ffffff',
                      }
                      : '',
                      ]"
                      >
                    </autocomplete>
                  </div>
                  <div class="form-group col-md-12">
                    <p>Matr.Serv/Instituidor:</p>
                    <b-form-input v-model="matriculaservidor" placeholder="Digite aqui a matricula" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': matriculaservidor.lenght > 6 }"></b-form-input>
                    <img
                    v-if="matriculaservidor.lenght > 6"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <p>Tipo Servidor:</p>
                    <b-form-select v-model="tipo_servidor" :options="options_tipo_servidor" :class="{ 'statusok-fontbold': tipo_servidor != null }" :style="[ tipo_servidor != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
                    >
                    <b-form-select-option :value="null">Selecione o tipo</b-form-select-option>
                  </b-form-select>
                </div>
                <div v-if="tipo_servidor==3" class="form-group col-md-12">
                  <p>Matrícula / Registro na Entidade Pensionista:</p>
                  <b-form-input v-model="matriculaservidorpensionista" placeholder="Digite aqui a matricula" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': matriculaservidorpensionista.lenght > 7 }"></b-form-input>
                  <img
                  v-if="matriculaservidorpensionista.lenght > 7"
                  class="statusok-check"
                  src="../assets/statusok.svg"
                  alt="Voltar etapa"
                  />
                </div>
              </div>
            </div>
            <div class="row" style="max-width: 680px; margin: 0 auto;">
              <div v-if="opcaoescolhida !== 3" class="form-row form-pagamento">
                <div class="form-group col-md-6">
                  <p>Banco:</p>
                  <b-form-select v-model="infoconta.banco" @change="setBankValidation($event)" :options="listabancos" :class="{ 'statusok-fontbold': infoconta.banco != null }" :style="[ infoconta.banco != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
                  >
                  <b-form-select-option :value="null">Selecione o banco</b-form-select-option>
                </b-form-select>
              </div>
              <div class="form-group col-md-3">
                <p>Agência:</p>
                <b-form-input v-model="infoconta.agencia" placeholder="-" @keydown="onKeydown($event)" maxlength="4" :class="{ 'statusok-fontbold': infoconta.agencia.length > 2 }"></b-form-input>
                <img
                v-if="infoconta.agencia.length > 2"
                class="statusok-check"
                src="../assets/statusok.svg"
                alt="Voltar etapa"
                />
              </div>
              <div class="form-group col-md-2">
                <p>Dígito:</p>
                <b-form-input v-model="infoconta.digitoag" :disabled="!validationInfoConta.hasDigitoAgencia" placeholder="-" @keydown="onKeydown($event)" maxlength="1" :class="{ 'statusok-fontbold': infoconta.digitoag && infoconta.digitoag.length > 0 }"></b-form-input>
                <img
                v-if="infoconta.digitoag && infoconta.digitoag.length > 0"
                class="statusok-check"
                src="../assets/statusok.svg"
                alt="Voltar etapa"
                />
              </div>
            </div>
            <div v-if="infoconta.banco" class="form-row form-pagamento" style="margin-top: 20px">
              <div v-if="infoconta.banco != 104" class="form-group col-md-6">
                <p>Tipo de conta:</p>
                <b-form-select v-model="infoconta.tipoconta" :options="listacontas" :class="{ 'statusok-fontbold': infoconta.tipoconta != null }" :style="[ infoconta.tipoconta != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
                >
                <b-form-select-option :value="null">Selecione a conta</b-form-select-option>
              </b-form-select>
            </div>
            <div v-else class="form-group col-md-6">
              <p>Operação:</p>
              <b-form-select v-model="infoconta.operacao" :class="{ 'statusok-fontbold': infoconta.operacao != null }" :style="[ infoconta.operacao != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]" tabindex="-1">
                <b-form-select-option :value="null">Informe o tipo de operação</b-form-select-option>
                <b-form-select-option value="001">001 - CONTA CORRENTE PESSOA FISICA</b-form-select-option>
                <b-form-select-option value="002">002 - CONTA SIMPLES PESSOA FISICA</b-form-select-option>
                <b-form-select-option value="003">003 - CONTA CORRENTE PESSOA JURIDICA</b-form-select-option>
                <b-form-select-option value="006">006 - ENTIDADES PUBLICAS</b-form-select-option>
                <b-form-select-option value="007">007 - DEP. INSTITUICOES FINANCEIRAS</b-form-select-option>
                <b-form-select-option value="013">013 - POUPANCA</b-form-select-option>
                <b-form-select-option value="022">022 - POUPANCA PESSOA JURIDICA</b-form-select-option>
                <b-form-select-option value="023">023 - CONTA CAIXA FACIL</b-form-select-option>
                <b-form-select-option value="028">028 - POUPANCA CREDITO IMOBILIARIO</b-form-select-option>
                <b-form-select-option value="043">043 - DEPOSITOS LOTERICOS</b-form-select-option>
                <b-form-select-option value="037">037 - CONTA SALARIO</b-form-select-option>
                <b-form-select-option value="131">131 - POUPANCA INTEGRADA</b-form-select-option>
                <b-form-select-option value="000001">000001 - EVENTO1</b-form-select-option>
              </b-form-select>
            </div>
            <div class="form-group col-md-3">
              <p>Conta:</p>
              <b-form-input v-model="infoconta.conta" placeholder="-" @keydown="onKeydown($event)" :maxlength="validationInfoConta.contaLength" :class="{ 'statusok-fontbold': infoconta.conta.length > 2 }"></b-form-input>
              <img
              v-if="infoconta.conta.length > 2"
              class="statusok-check"
              src="../assets/statusok.svg"
              alt="Voltar etapa"
              />
            </div>
            <div class="form-group col-md-2">
              <p>Dígito:</p>
              <b-form-input v-model="infoconta.digitoconta" placeholder="-" @keydown="onKeydown($event)" maxlength="1" :class="{ 'statusok-fontbold': infoconta.digitoconta.length > 0 }"></b-form-input>
              <img
              v-if="infoconta.digitoconta.length > 0"
              class="statusok-check"
              src="../assets/statusok.svg"
              alt="Voltar etapa"
              />
            </div>
          </div>
        </div>
        <div v-if="opcaoescolhida !== 3" class="row" style="max-width: 680px; margin: 0 auto; margin-top: 64px;">
          <b-col cols="6" class="text-header-pagamento">
            Deseja manter Dados de Débito em conta para Reembolso?
          </b-col>
          <b-col cols="6" style="display: flex; justify-content: space-between;">
            <b-button id="activereembolsoy" @click="showcontaopcional(false); changebtncolor($event)">Sim</b-button>
            <b-button id="activereembolson" @click="showcontaopcional(true); changebtncolor($event)">Não</b-button>
          </b-col> 
        </div>
        <div v-if="contaOpcional" id="conta-opcional" class="row" style="max-width: 680px; margin: 0 auto; margin-top: 64px; display: block;">
          <div class="text-header-pagamento">
            Informe os dados de conta para reembolso:
          </div>
          <div class="form-row form-pagamento">
            <div class="form-group col-md-6">
              <p>Banco:</p>
              <b-form-select v-model="infocontaopcional.banco" @change="setAuxBankValidation($event)" :options="listabancos" :class="{ 'statusok-fontbold': infocontaopcional.banco != null }" :style="[ infocontaopcional.banco != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
              >
              <b-form-select-option :value="null">Selecione o banco</b-form-select-option>
            </b-form-select>
          </div>
          <div class="form-group col-md-3">
            <p>Agência:</p>
            <b-form-input v-model="infocontaopcional.agencia" placeholder="-" @keydown="onKeydown($event)" maxlength="4" :class="{ 'statusok-fontbold': infocontaopcional.agencia.length > 2 }"></b-form-input>
            <img
            v-if="infocontaopcional.agencia.length > 2"
            class="statusok-check"
            src="../assets/statusok.svg"
            alt="Voltar etapa"
            />
          </div>
          <div class="form-group col-md-2">
            <p>Dígito:</p>
            <b-form-input v-model="infocontaopcional.digitoag" :disabled="!validationInfoContaOpcional.hasDigitoAgencia" placeholder="-" @keydown="onKeydown($event)" maxlength="1" :class="{ 'statusok-fontbold': infocontaopcional.digitoag && infocontaopcional.digitoag.length > 0 }"></b-form-input>
            <img
            v-if="infocontaopcional.digitoag && infocontaopcional.digitoag.length > 0"
            class="statusok-check"
            src="../assets/statusok.svg"
            alt="Voltar etapa"
            />
          </div>
        </div>
        <div v-if="infocontaopcional.banco" class="form-row form-pagamento" style="margin-top: 20px">
          <div v-if="infocontaopcional.banco != 104" class="form-group col-md-6">
            <p>Tipo de conta:</p>
            <b-form-select v-model="infocontaopcional.tipoconta" :options="listacontas" :class="{ 'statusok-fontbold': infocontaopcional.tipoconta != null }" :style="[ infocontaopcional.tipoconta != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
            >
            <b-form-select-option :value="null">Selecione a conta</b-form-select-option>
          </b-form-select>
        </div>
        <div v-else class="form-group col-md-6">
          <p>Operação:</p>
          <b-form-select v-model="infocontaopcional.operacao" :class="{ 'statusok-fontbold': infocontaopcional.operacao != null }" :style="[ infocontaopcional.operacao != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]" tabindex="-1">
            <b-form-select-option :value="null">Informe o tipo de operação</b-form-select-option>
            <b-form-select-option value="001">001 - CONTA CORRENTE PESSOA FISICA</b-form-select-option>
            <b-form-select-option value="002">002 - CONTA SIMPLES PESSOA FISICA</b-form-select-option>
            <b-form-select-option value="003">003 - CONTA CORRENTE PESSOA JURIDICA</b-form-select-option>
            <b-form-select-option value="006">006 - ENTIDADES PUBLICAS</b-form-select-option>
            <b-form-select-option value="007">007 - DEP. INSTITUICOES FINANCEIRAS</b-form-select-option>
            <b-form-select-option value="013">013 - POUPANCA</b-form-select-option>
            <b-form-select-option value="022">022 - POUPANCA PESSOA JURIDICA</b-form-select-option>
            <b-form-select-option value="023">023 - CONTA CAIXA FACIL</b-form-select-option>
            <b-form-select-option value="028">028 - POUPANCA CREDITO IMOBILIARIO</b-form-select-option>
            <b-form-select-option value="043">043 - DEPOSITOS LOTERICOS</b-form-select-option>
            <b-form-select-option value="037">037 - CONTA SALARIO</b-form-select-option>
            <b-form-select-option value="131">131 - POUPANCA INTEGRADA</b-form-select-option>
            <!-- <b-form-select-option value="000001">000001 - EVENTO1</b-form-select-option> -->
          </b-form-select>
        </div>                    
        <div class="form-group col-md-3">
          <p>Conta:</p>
          <b-form-input v-model="infocontaopcional.conta" placeholder="-" @keydown="onKeydown($event)" :maxlength="validationInfoContaOpcional.contaLength" :class="{ 'statusok-fontbold': infocontaopcional.conta && infocontaopcional.conta.length > 2 }"></b-form-input>
          <img
          v-if="infocontaopcional.conta.length > 2"
          class="statusok-check"
          src="../assets/statusok.svg"
          alt="Voltar etapa"
          />
        </div>
        <div class="form-group col-md-2">
          <p>Dígito:</p>
          <b-form-input v-model="infocontaopcional.digitoconta" placeholder="-" @keydown="onKeydown($event)" maxlength="1" :class="{ 'statusok-fontbold': infocontaopcional.digitoconta.length > 0 }"></b-form-input>
          <img
          v-if="infocontaopcional.digitoconta.length > 0"
          class="statusok-check"
          src="../assets/statusok.svg"
          alt="Voltar etapa"
          />
        </div>
      </div>
    </div>
    <div v-if="opcaoescolhida != 3" class="row resp-financeiro-pagamento">
      <b-col cols="6" class="text-header-pagamento">
        O responsável financeiro é o Titular?
      </b-col>
      <b-col cols="6" style="display: flex; justify-content: space-between;">
        <b-button id="resptitulary" @click="showformrespfinanceiro(false); changebtncolorresp($event)">Sim</b-button>
        <b-button id="resptitularn" @click="showformrespfinanceiro(true); changebtncolorresp($event)">Não</b-button>
      </b-col> 
    </div>
    <div class="row vencimento-wrapper">
      <b-col cols="6" class="text-header-pagamento">
        Escolha o dia de vencimento:
      </b-col>
      <b-col cols="6" class="btns-dia-vencimento">
        <b-button v-for="dia in diasvencimento" :key="dia" @click="diavencimento = dia" class="dia-vencimento" :class="{'btn-clicked-dps': dia === diavencimento}">Dia {{dia}}</b-button>
      </b-col> 
    </div>
    <div id="form-respfinanceiro" class="row" style="max-width: 680px; margin: 0 auto; margin-top: 64px; display: none">
      <div class="text-header-pagamento">
        Informe os dados do responsável financeiro:
      </div>
      <div class="form-row form-pagamento">
        <div class="form-group col-md-12">
          <p>Nome do responsável:</p>
          <b-form-input v-model="nomerespfinanceiro" :formatter="formatter" placeholder="Informe o nome do responsável financeiro" :class="{ 'statusok-fontbold': nomerespfinanceiro.length > 2 && nomerespfinanceiro.indexOf(' ') > 0 }"></b-form-input>
          <img
          v-if="nomerespfinanceiro.length > 2 && nomerespfinanceiro.indexOf(' ') > 0"
          class="statusok-check"
          src="@/assets/statusok.svg"
          alt="Check"
          />
        </div>
        <div class="form-group col-md-12">
          <p>CPF:</p>
          <b-form-input v-model="cpfrespfinanceiro" placeholder="Digite aqui o CPF" v-mask="'###.###.###-##'" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': cpfrespfinanceiro.length > 13 }"></b-form-input>
          <img
          v-if="cpfrespfinanceiro.length > 13"
          class="statusok-check"
          src="../assets/statusok.svg"
          alt="Voltar etapa"
          />
        </div>
        <div class="form-group col-md-12">
          <p>Email:</p>
          <b-form-input :formatter="formatter" v-model="emailrespfinanceiro" placeholder="Digite aqui o Email" :class="{ 'statusok-fontbold': emailrespfinanceiro.indexOf('@') > 0 && emailrespfinanceiro.indexOf('.') > 0 }"></b-form-input>
          <img
          v-if="emailrespfinanceiro.indexOf('@') > 0 && emailrespfinanceiro.indexOf('.') > 0"
          class="statusok-check"
          src="@/assets/statusok.svg"
          alt="OK"
          />
        </div>
        <div class="form-group col-md-12">
          <p>Confirme o Email:</p>
          <b-form-input :formatter="formatter" v-model="confirmaemailrespfinanceiro" placeholder="Confirme aqui o Email" :class="{ 'statusok-fontbold': confirmaemailrespfinanceiro == emailrespfinanceiro && confirmaemailrespfinanceiro != ''}"></b-form-input>
          <img
          v-if="confirmaemailrespfinanceiro == emailrespfinanceiro && confirmaemailrespfinanceiro != ''"
          class="statusok-check"
          src="@/assets/statusok.svg"
          alt="OK"
          />
        </div>
      </div>
    </div>
    <!-- TESTE VALIDAÇÃO -->
    <div v-if="errors.length" style="width: 100%"> 
      <b v-for="erro in errors" :key="erro">{{ erro }}<br> </b>                    
    </div> 
    <div class="row" style="margin: 0 auto; max-width: 680px; margin-top: 102px;">
      <div @click="gotofinalizar(opcaoescolhida)">
        <b-button class="btn-alianca btn-next btn-next-continuar-pagamento-nomargin btn-clicked">CONFIRMAR E CONTINUAR</b-button>
        <b-button class="btn-alianca btn-next btn-icon-next btn-clicked-icon"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
      </div>
    </div> 
    <div v-if="opcaoescolhida==1" class="row" style="margin: 0 auto; max-width: 680px; margin-top: 54px;">
      <p class="text-footer-pagamento">
        <b>Escolha Consignação em Folha e tenha muito mais praticidade e segurança no pagamento da mensalidade do seu plano de saúde ou odontológico?</b><br><br>
        <span>- Acompanhe mensalmente o desconto do plano no contracheque e não corra risco de suspensão de atendimento em razão de um débito automático não realizado.</span><br><br>
        <span>- Garantia de receber o Auxílio-Saúde. O atraso na realização do débito automático pode adiar o crédito do ressarcimento concedido pelo seu órgão.</span>
      </p>
    </div>
  </div>
</transition>

            <!-- <transition name="fade">
              <div id="consignacao-form" class="multi-step-form active-step top-border-pagamento" style="display: none">
                <div class="row" style="max-width: 680px; margin: 0 auto;">
                  <div class="form-row form-pagamento">
                     <div class="form-group col-md-6">
                      <p>Banco:</p>
                      <b-form-select v-model="infoconta.banco" :options="listabancos" @change="getProfissoes('entidadeclasse')"
                        :class="{ 'statusok-fontbold': infoconta.banco != null }" :style="[ infoconta.banco != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
                      >
                        <b-form-select-option :value="null">Selecione o banco</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="form-group col-md-3">
                      <p>Agência:</p>
                      <b-form-input v-model="infoconta.agencia" placeholder="-" @keydown="onKeydown($event)" maxlength="10"></b-form-input>
                    </div>
                    <div class="form-group col-md-2">
                      <p>Dígito:</p>
                      <b-form-input v-model="infoconta.digitoag" placeholder="-" @keydown="onKeydown($event)" maxlength="1"></b-form-input>
                    </div>
                  </div>
                  <div class="form-row form-pagamento" style="margin-top: 20px">
                     <div class="form-group col-md-6">
                      <p>Tipo de conta:</p>
                      <b-form-select v-model="infoconta.tipoconta" :options="listacontas" @change="getProfissoes('entidadeclasse')"
                        :class="{ 'statusok-fontbold': infoconta.tipoconta != null }" :style="[ infoconta.tipoconta != null ? { 'background': 'url(' + require('../assets/statusok.svg') + ') no-repeat right 2.6% center #ffffff' } : '' ]"
                      >
                        <b-form-select-option :value="null">Selecione a conta</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="form-group col-md-3">
                      <p>Conta:</p>
                      <b-form-input v-model="infoconta.conta" placeholder="-" @keydown="onKeydown($event)" maxlength="10"></b-form-input>
                    </div>
                    <div class="form-group col-md-2">
                      <p>Dígito:</p>
                      <b-form-input v-model="infoconta.digitoconta" placeholder="-" @keydown="onKeydown($event)" maxlength="1"></b-form-input>
                    </div>
                  </div>
                  <div v-if="errors.length" style="width: 100%"> 
                    <b v-for="erro in errors" :key="erro">{{ erro }}</b>                    
                  </div> 
                </div>
                <div class="row" style="margin: 0 auto; max-width: 680px; margin-top: 102px;">
                  <div @click="gotofinalizar(2)">
                    <b-button class="btn-alianca btn-next btn-next-continuar-pagamento-nomargin" :class="{ 'btn-clicked': infoconta.digitoconta != '' }" :disabled="infoconta.digitoconta == ''">CONFIRMAR E CONTINUAR</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next" :class="{ 'btn-clicked-icon': infoconta.digitoconta != '' }" :disabled="infoconta.digitoconta == ''"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                  </div>
                </div> 
              </div>
            </transition> -->

          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueMask from 'v-mask'
  import Loading from 'vue-loading-overlay';
  import obterFormasPagamento from "../services/obterFormasPagamento.js"
  import BankAccountValidator from "validacao-bancaria-brasileira";
  // import listaBancos from "../services/listaBancos.js"
  import listaBancos from "../services/lerBancos.js"
  import unidadePagadora from "../services/lerUnidadePagamento.js"
  import store from "../store"
  Vue.use(VueMask);

  export default {
    name: 'Pagamento',
    mixins: [],
    components: {
      Loading
    },
    data(){
      return {
        contaOpcional: null,
        etapa: 'step-9',
        listabancos: [],
        listacontas: [
        { value: '1', text: 'CORRENTE'},
        { value: '2', text: 'POUPANCA'},
        ],
        infoconta: {
          banco: '',
          agencia: '',
          digitoag: '',
          tipoconta: '',
          conta: '',
          digitoconta: '',
        },
        validationInfoConta:{
          banco: true,
          agencia: false,
          digitoag: false,
          tipoconta: false,
          conta: false,
          contaLength: 11,
          hasDigitoAgencia: false,
        },
        infocontaopcional: {
          habilitareembolso: true,
          banco: '',
          agencia: '',
          digitoag: '',
          tipoconta: '',
          conta: '',
          digitoconta: '',
          operacao: ''
        },
        validationInfoContaOpcional:{
          banco: true,
          agencia: false,
          digitoag: false,
          tipoconta: false,
          conta: false,
          contaLength: 11,
          hasDigitoAgencia: false,
        },
        opflag: 0,
        errors: [],
        exibedebito: false,
        exibeconsignacao: false,
        exibeboleto: false,
        colsystem: 0,
        isLoading: true,
        opcaoescolhida: null,
        nomerespfinanceiro: '',
        cpfrespfinanceiro: '',
        emailrespfinanceiro: '',
        confirmaemailrespfinanceiro: '',
        flagrespfinanceiro: null,
        matriculaservidor: '',
        unidadepagadora: null,
        tipo_servidor: null,
        matriculaservidorpensionista: '',
        options_tipo_servidor: [
        { value: 1, text: 'Ativo' },
        { value: 2, text: 'Inativo' },
        { value: 3, text: 'Pensionista' },
        ],
        options_unidadepagadora: [],
        diasvencimento: '',
        diavencimento: '',
        flagtipoorgao: '' 
      }
    },
    methods: {
      setBankValidation(val){
        console.log(val)
        switch (val) {
          // Banco do Brasil
          case '001':
          if(this.infoconta.conta){
            this.infoconta.conta = this.infoconta.conta.substring(0,8)
          }
          this.validationInfoConta.hasDigitoAgencia = true;
          this.validationInfoConta.contaLength = 7;

          break;

          // BRADESCO
          case '237':
          if(this.infoconta.conta){
            this.infoconta.conta = this.infoconta.conta.substring(0,7)
          }
          this.validationInfoConta.hasDigitoAgencia = true;
          this.validationInfoConta.contaLength = 7;
          break;

          // ITAU
          case '341':
          if(this.infoconta.conta){
            this.infoconta.conta = this.infoconta.conta.substring(0,5)
          }
          this.validationInfoConta.hasDigitoAgencia = false;
          this.infoconta.digitoag = null
          this.validationInfoConta.contaLength = 5;
          break;

          // SICOOB
          case '756':
          if(this.infoconta.conta){
            this.infoconta.conta = this.infoconta.conta.substring(0,8)
          }
          this.validationInfoConta.hasDigitoAgencia = false;
          this.infoconta.digitoag = null
          this.validationInfoConta.contaLength = 8;
          break;

          // Santander
          case '033':
          if(this.infoconta.conta){
            this.infoconta.conta = this.infoconta.conta.substring(0,8)
          }
          this.validationInfoConta.hasDigitoAgencia = false;
          this.infoconta.digitoag = null
          this.validationInfoConta.contaLength = 8;
          break;

            // CAIXA
            case '104':
            if(this.infoconta.conta){
              this.infoconta.conta = '';
            }
            this.validationInfoConta.hasDigitoAgencia = false;
            this.infoconta.digitoag = null
            this.validationInfoConta.contaLength = 8;

            break;

            default:
            this.infoconta.conta.padStart(12,0)
            this.validationInfoConta.hasDigitoAgencia = false;
            this.infoconta.digitoag = null
            this.validationInfoConta.contaLength = 8;
            break;
          }
        },
        setAuxBankValidation(val){
          switch (val) {
          // Banco do Brasil
          case '001':
          if(this.infocontaopcional.conta){
            this.infocontaopcional.conta = this.infocontaopcional.conta.substring(0,8)
          }
          this.validationInfoContaOpcional.hasDigitoAgencia = true;
          this.validationInfoContaOpcional.contaLength = 7;

          break;

          // BRADESCO
          case '237':
          if(this.infocontaopcional.conta){
            this.infocontaopcional.conta = this.infocontaopcional.conta.substring(0,7)
          }
          this.validationInfoContaOpcional.hasDigitoAgencia = true;
          this.validationInfoContaOpcional.contaLength = 7;
          break;

          // ITAU
          case '341':
          if(this.infocontaopcional.conta){
            this.infocontaopcional.conta = this.infocontaopcional.conta.substring(0,5)
          }
          this.validationInfoContaOpcional.hasDigitoAgencia = false;
          this.infocontaopcional.digitoag = null
          this.validationInfoContaOpcional.contaLength = 5;
          break;

          // SICOOB
          case '756':
          if(this.infocontaopcional.conta){
            this.infocontaopcional.conta = this.infocontaopcional.conta.substring(0,8)
          }
          this.validationInfoContaOpcional.hasDigitoAgencia = false;
          this.infocontaopcional.digitoag = null
          this.validationInfoContaOpcional.contaLength = 8;
          break;

          // Santander
          case '033':
          if(this.infocontaopcional.conta){
            this.infocontaopcional.conta = this.infocontaopcional.conta.substring(0,8)
          }
          this.validationInfoContaOpcional.hasDigitoAgencia = false;
          this.infocontaopcional.digitoag = ''
          this.validationInfoContaOpcional.contaLength = 8;
          break;

            // CAIXA
            case '104':
            if(this.infocontaopcional.conta){
              this.infocontaopcional.conta = '';
            }
            this.validationInfoContaOpcional.hasDigitoAgencia = false;
            this.infocontaopcional.digitoag = null
            this.validationInfoContaOpcional.contaLength = 8;

            break;

            default:
            this.infocontaopcional.conta.padStart(12,0)
            this.validationInfoContaOpcional.hasDigitoAgencia = false;
            this.infocontaopcional.digitoag = ''
            this.validationInfoContaOpcional.contaLength = 8;
            break;
          }
        },
        validaSicoob(conta, digitoconta){
          conta = conta.substring(0,8)
          for (var i = 0, a = 9, n = conta.split('').reverse(), s = 0; i < conta.length; i++, a--)
            s += parseInt(n[i]) * a;
          if ((s %= 11) > 10) {
            s = 0;
          }
          if (Number(s) != digitoconta) {
            return false;
          } else return true;
        },
        validaCaixa(agencia, operacao, conta,digConta) {

          let seq = agencia + operacao + conta;
          let x = this.DigitoModulo11(seq);
          if (x != digConta) {
            return false;
          }
          return true;
        },
        /* eslint-disable no-undef */
         validaSantander(agencia, conta){
             // eslint-disable-next-line no-unused-vars
            var auxAccount = conta;
            if (agencia.length < 4) {
                agencia = this.preencheZeros(agencia, 4);
            }

            if (agencia > 3000){
                let contaLeft
                let contaRight
                if(conta.length < 9){
                    if (conta.substring(0,1) == "1" && conta.substring(0,2) != "13"){
                        contaLeft = conta.substring(0,1)
                        contaRight = conta.substring(1,conta.length)
                    }else{
                        contaLeft = conta.substring(0,2)
                        contaRight = conta.substring(2,conta.length)
                    }
                    contaLeft = this.preencheZerosVar(contaLeft,2);
                    contaRight = this.preencheZerosVar(contaRight,7);
                    conta = contaLeft.toString() + contaRight.toString();
                }
              
                if (!this.CheckDigitoBNP(agencia, conta)) {
                    return false;
                }
                else
                {
                    return true;
                }
              
            } else if (conta.length == 8) {
                let contaLeft
                let contaRight
                if (conta.substring(0, 1) == "1" && conta.substring(0, 2) != "13") {
                    contaLeft = conta.substring(0, 1)
                    contaRight = conta.substring(1, conta.length)
                } else {
                    contaLeft = conta.substring(0, 2)
                    contaRight = conta.substring(2, conta.length)
                }
                contaLeft = this.preencheZerosVar(contaLeft, 2);
                contaRight = this.preencheZerosVar(contaRight, 7);
                conta = contaLeft.toString() + contaRight.toString();        
                if (!this.CheckDigitoBNP(agencia, conta)) {
                    return false;
                }
                else {
                    return true;
                }

            } else {
                if (this.CheckDigitoBNP(agencia, conta)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        CheckDigitoBNP(auxAgencia, auxConta) {
        //3100 010010417
        var auxPeso = new Array("9", "7", "3", "1", "9", "7", "1", "3", "1", "9", "7", "3");
        var cont = 0;
        var soma = 0;
        var digito = 0;
        var auxRet = false;
        var auxAgenciaConta = auxAgencia.toString() + auxConta.toString();
        for (cont = 0; cont < 12; cont++)
        {
            soma = soma + ((auxAgenciaConta.substring(cont, cont + 1) * auxPeso[cont]) % 10);
        }
        digito = (10 - (soma % 10)) % 10;
        var d = auxAgenciaConta.substring(12, 13);
        if (parseInt(digito) == parseInt(d)) {
            auxRet = true;
        }
        return auxRet;
        },
        preencheZerosVar(variavel, size)
        { while (variavel.length < size) { variavel = '0' + variavel } return variavel; },
        preencheZeros(field, size) 
        { while (field.value.length < size) field.value = '0' + field.value; },
        DigitoModulo11(sequencia) {
          let seq = sequencia;
          let soma = 0;
          let multiplicador = 2;
          for (let f = seq.length - 1; f >= 0; f--) {
            let val_temp = seq.substring(f, f + 1);
            soma += val_temp * multiplicador;
            multiplicador++;
            if (multiplicador > 9) multiplicador = 2;
          }
          let resto = soma % 11;
          if (resto == 1) return 0;
          if (resto == 0) return 0;
          resto = 11 - resto;
          return resto;
        },
        formatter(val){
          return val.toUpperCase();
        },
        onKeydown: function(e) {
          if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || (e.keyCode === 88) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
          ) return;
            e.preventDefault();
          e.stopPropagation();        

        },
        TestaCPF(strCPF) {
          let Soma
          let Resto
          Soma = 0
          if (strCPF == "00000000000") return false

            for ( let i = 1; i <= 9; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
              Resto = (Soma * 10) % 11

            if ((Resto == 10) || (Resto == 11))  Resto = 0
              if (Resto != parseInt(strCPF.substring(9, 10)) ) return false

                Soma = 0;
              for ( let i = 1; i <= 10; i++ ) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
                Resto = (Soma * 10) % 11

              if ((Resto == 10) || (Resto == 11))  Resto = 0
                if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
                  return true
              },   
              validaAdicional(){
        // let length;

        switch (this.infoconta.banco) {
          // Banco do Brasil
          case '001':
          this.infoconta.conta = this.infoconta.conta.padStart(8,0)
          if(this.infoconta.digitoconta === 'X' || this.infoconta.digitoconta === 'x'){
            this.infoconta.digitoconta = 'X';
          }
          break;
          // Bradesco
          case '237':
          this.infoconta.conta = this.infoconta.conta.padStart(7,0)
          break;
          // Itaú
          case '341':
          this.infoconta.conta = this.infoconta.conta.padStart(5,0)
          break;
          // Santander
          default:
          this.infoconta.conta = this.infoconta.conta.padStart(8,0)
          break;
        }

        if(this.infoconta.banco === '104'){
          let agencia = this.infoconta.agencia
          let operacao = this.infoconta.operacao
          let conta = this.infoconta.conta
          let digConta = this.infoconta.digitoconta
          let res = this.validaCaixa(agencia, operacao, conta, digConta)
          if(!res){
            this.errors.push('Conta caixa inválida!')
            return false;
          }
          console.log('Conta caixa valida!')
          return true
        }
        if(this.infoconta.banco === '033'){
         let agencia = this.infoconta.agencia
         let conta = this.infoconta.conta + this.infoconta.digitoconta
         let res = this.validaSantander(agencia, conta)
         if(!res){
            this.errors.push('Conta santander inválida!')
            return false
          }
          console.log(`Conta santander validada!' num. ${this.infoconta.conta}`)
          return true
        }

        if(this.infoconta.banco === '756'){
          let res = this.validaSicoob( this.infoconta.conta , this.infoconta.digitoconta )
          if(!res){
            this.errors.push('Conta sicoob inválida!')
            return false;
          }
          console.log('Conta sicoob valida!')
          return true
        }

        if(!['104', '756', '033'].includes(this.infoconta.banco)){
          try {
            BankAccountValidator.validate({
              bankNumber: this.infoconta.banco,
              agencyNumber: this.infoconta.agencia,
              agencyCheckNumber: this.infoconta.digitoag ? (this.infoconta.digitoag).toString() : '',
              accountNumber: this.infoconta.conta,
              accountCheckNumber: this.infoconta.digitoconta,
            });
            console.log('Válido ' + this.infoconta.conta.padStart(12,0)) +' banco: ' + this.infoconta.banco ;
            return true
          } catch (e) {
            var errors = e.message.split('.');
            errors.forEach(err => this.errors.push(err))
            return false
          }
        }
      },
      validaInfoAdicional(){
        // let length;

        switch (this.infocontaopcional.banco) {
          // Banco do Brasil
          case '001':
          this.infocontaopcional.conta = this.infocontaopcional.conta.padStart(8,0)
          if(this.infocontaopcional.digitoconta === 'X' || this.infocontaopcional.digitoconta === 'x'){
            this.infocontaopcional.digitoconta = 'X';
          }
          break;
          // Bradesco
          case '237':
          this.infocontaopcional.conta = this.infocontaopcional.conta.padStart(7,0)
          break;
          // Itaú
          case '341':
          this.infocontaopcional.conta = this.infocontaopcional.conta.padStart(5,0)
          break;
          // Santander
          case '033':
          this.infocontaopcional.conta = this.infocontaopcional.conta.padStart(5,0)
          break;
          default:
          this.infocontaopcional.conta = this.infocontaopcional.conta.padStart(8,0)
          break;
        }

        if(this.infocontaopcional.banco === '104'){
          let agencia = this.infocontaopcional.agencia
          let operacao = this.infocontaopcional.operacao
          let conta = this.infocontaopcional.conta
          let digConta = this.infocontaopcional.digitoconta
          let res = this.validaCaixa(agencia, operacao, conta, digConta)
          if(!res){
            this.errors.push('Conta caixa inválida!')
            return false
          }
          console.log(`Conta caixa validada!' num. ${this.infocontaopcional.conta}`)
          return true
        }

        if(this.infocontaopcional.banco === '033'){
         let agencia = this.infocontaopcional.agencia
         let conta = this.infocontaopcional.conta + this.infocontaopcional.digitoconta
         let res = this.validaSantander(agencia, conta)
         if(!res){
            this.errors.push('Conta santander inválida!')
            return false
          }
          console.log(`Conta santander validada!' num. ${this.infocontaopcional.conta}`)
          return true
        }

        if(this.infocontaopcional.banco === '756'){
          let res = this.validaSicoob( this.infocontaopcional.conta , this.infocontaopcional.digitoconta)
          if(!res){
            this.errors.push('Conta sicoob inválida!')
            return false
          }
          console.log(`Conta sicoob/bancoob validada! num. ${this.infocontaopcional.conta}`)
          return true
        }

        if(!['104', '756', '033'].includes(this.infocontaopcional.banco)){
          try {
            BankAccountValidator.validate({
              bankNumber: this.infocontaopcional.banco,
              agencyNumber: this.infocontaopcional.agencia,
              agencyCheckNumber: this.infocontaopcional.digitoag ? (this.infocontaopcional.digitoag).toString() : '',
              accountNumber: this.infocontaopcional.conta,
              accountCheckNumber: this.infocontaopcional.digitoconta,
            });
            console.log('Válido ' + this.infocontaopcional.conta.padStart(12,0));
          // Se chegou até aqui, a conta bancária é válida
          return true
        } catch (e) {
              // se não for válida, lança uma exceção
              var errors = e.message.split('.');
              errors.forEach(err => this.errors.push(err + '\n'))
              return false
            }
          }
        },
        validaCadastro(){
          this.errors = []

          if (this.opcaoescolhida === 1 || this.opcaoescolhida === 2) {

            if ( this.infoconta.banco == null ) {
              this.errors.push('Selecione um banco válido')
              return false
            }

            if ( !this.infoconta.agencia ) {
              this.errors.push('Insira um numero de agência válido')
              return false
            }

            if ( this.infoconta.banco != '104' ) {
              if (this.infoconta.tipoconta == null){
                this.errors.push('Selecione um tipo de conta válido')
              }
            } else if (this.infoconta.operacao == null){
              this.errors.push('Selecione uma operação válida')
            } 

            if ( !this.infoconta.conta ) {
              this.errors.push('Insira um numero de conta válido')
              return false
            }

            if ( !this.infoconta.digitoconta ) {
              this.errors.push('Informe o digito da conta')
            }
            if ( this.flagrespfinanceiro === null ){
              this.errors.push('Informe se o responsável financeiro é o titular')
              return false
            }
            if ( this.flagrespfinanceiro ){
              if ( !this.nomerespfinanceiro ) {
                this.errors.push('Informe o nome do responsável financeiro')
                return false
              }

              if ( !this.cpfrespfinanceiro ) {
                this.errors.push('Informe o CPF do responsável financeiro')
                return false
              }

              if ( !this.TestaCPF(this.cpfrespfinanceiro.replace('-','').replace('.', '').replace('.', '')) ) {
                this.errors.push('Informe corretamente o CPF do responsável financeiro')
                return false
              }

              if ( !this.emailrespfinanceiro ) {
                this.errors.push('Informe o email do responsável financeiro')
                return false
              }

              if ( !this.confirmaemailrespfinanceiro ) {
                this.errors.push('Confirme o email do responsável financeiro')
                return false
              }

              if ( this.emailrespfinanceiro != this.confirmaemailrespfinanceiro ) {
                this.errors.push('O email informado para o responsável financeiro está diferente nos dois campos')
                return false
              }
            }
          }

          if ( this.flagrespfinanceiro ){
            if ( !this.nomerespfinanceiro ) {
              this.errors.push('Informe o nome do responsável financeiro')
              return false
            }

            if ( !this.cpfrespfinanceiro ) {
              this.errors.push('Informe o CPF do responsável financeiro')
              return false
            }

            if ( !this.TestaCPF(this.cpfrespfinanceiro.replace('-','').replace('.', '').replace('.', '')) ) {
              this.errors.push('Informe corretamente o CPF do responsável financeiro')
              return false
            }

            if ( !this.emailrespfinanceiro ) {
              this.errors.push('Informe o email do responsável financeiro')
              return false
            }

            if ( !this.confirmaemailrespfinanceiro ) {
              this.errors.push('Confirme o email do responsável financeiro')
              return false
            }

            if ( this.emailrespfinanceiro != this.confirmaemailrespfinanceiro ) {
              this.errors.push('O email informado para o responsável financeiro está diferente nos dois campos')
              return false
            }
          }
          

          if ( this.flagtipoorgao == 3 && this.opcaoescolhida == 2 ){
            if ( !this.matriculaservidor ) {
              this.errors.push('Informe o numero da matricula do servidor')
              return false
            }

            if ( !this.unidadepagadora ) {
              this.errors.push('Informe a unidade pagadora do servidor')
              return false
            }

            if ( !this.tipo_servidor ) {
              this.errors.push('Informe o tipo do servidor')
              return false
            }

            if ( this.tipo_servidor == 3 ){
              if ( !this.matriculaservidorpensionista ) {
                this.errors.push('Informe o numero de matricula do servidor pensionista')
                return false
              }
            }
          }
          if ( this.flagrespfinanceiro === null && !this.opcaoescolhida == 3 ){
            this.errors.push('Informe se o responsável financeiro é o titular')
            return false
          }

          if ( this.flagrespfinanceiro ){
            if ( !this.nomerespfinanceiro ) {
              this.errors.push('Informe o nome do responsável financeiro')
              return false
            }

            if ( !this.cpfrespfinanceiro ) {
              this.errors.push('Informe o CPF do responsável financeiro')
              return false
            }

            if ( !this.TestaCPF(this.cpfrespfinanceiro.replace('-','').replace('.', '').replace('.', '')) ) {
              this.errors.push('Informe corretamente o CPF do responsável financeiro')
              return false
            }

            if ( !this.emailrespfinanceiro ) {
              this.errors.push('Informe o email do responsável financeiro')
              return false
            }

            if ( !this.confirmaemailrespfinanceiro ) {
              this.errors.push('Confirme o email do responsável financeiro')
              return false
            }

            if ( this.emailrespfinanceiro != this.confirmaemailrespfinanceiro ) {
              this.errors.push('O email informado para o responsável financeiro está diferente nos dois campos')
              return false
            }
          }
          if (this.contaOpcional === null) {
            this.errors.push('Informe se deseja manter os dados de débito em conta para reembolso')
            return false
          }

          if ( this.contaOpcional ){
            if ( this.infocontaopcional.banco == null ) {
              this.errors.push('Selecione um banco válido para dados de reembolso')
              return false
            }

            if ( !this.infocontaopcional.agencia ) {
              this.errors.push('Insira um numero de agência válido para dados de reembolso')
              return false
            }

            if ( this.infocontaopcional.banco != '104' ) {
              if (this.infocontaopcional.tipoconta == null){
                this.errors.push('Selecione um tipo de conta válido para dados de reembolso')
              }
            }
            if ( this.infocontaopcional.banco === '104' && this.infocontaopcional.operacao == null){
              this.errors.push('Selecione uma operação válida para dados de reembolso')
            } 

            if ( !this.infocontaopcional.conta ) {
              this.errors.push('Insira um numero de conta válido para dados de reembolso')
              return false
            }

            if ( !this.infocontaopcional.digitoconta ) {
              this.errors.push('Informe o digito da conta para dados de reembolso')
              return false
            }
          }

          if (this.contaOpcional){
            if ( this.opcaoescolhida == 3){
              if(this.validaInfoAdicional()){
                return true
              } else return false
            } else {
              if(this.validaAdicional() && this.validaInfoAdicional()){
                return true
              }
            } return false
          } else if (this.validaAdicional()) return true
          else return false
        },      
      backtodps(){
        // localStorage.removeItem('AliancaObjInfoPagamento')
        this.$router.push("declaracao-saude")
      },
      showformconta(param){
        this.contaOpcional = null
        this.resetContasInfo()
        if (param == 1){
          this.opcaoescolhida = 1
        } else if (param == 2) {
          this.opcaoescolhida = 2
        } else {
          this.opcaoescolhida = 3
          this.contaOpcional = true
        }
        document.getElementById('conta-form').style.display = 'block'
      },
      resetContasInfo() {
        this.infoconta = {
          banco: null,
          agencia: '',
          digitoag: '',
          tipoconta: null,
          conta: '',
          digitoconta: '',
        },
        this.infocontaopcional = {
          habilitareembolso: true,
          banco: null,
          agencia: '',
          digitoag: '',
          tipoconta: null,
          conta: '',
          digitoconta: '',
          operacao: null
        }
      },
      resetAllContasInfo() {
        this.infoconta = {
          agencia: '',
          digitoag: '',
          tipoconta: null,
          conta: '',
          digitoconta: '',
        },
        this.infocontaopcional = {
          habilitareembolso: true,
          banco: null,
          agencia: '',
          digitoag: '',
          tipoconta: null,
          conta: '',
          digitoconta: '',
          operacao: null
        }
      },
      showcontaopcional(status){
        if (status){
          this.contaOpcional = true
        } else {
          this.contaOpcional = false
        }
      },
      showformrespfinanceiro(status){
        if (status){
          document.getElementById('form-respfinanceiro').style.display = 'block'
          this.flagrespfinanceiro = true
        } else {
          document.getElementById('form-respfinanceiro').style.display = 'none'
          this.flagrespfinanceiro = false 
        }
      },
      changebtncolor(event){
        let id = event.currentTarget.id
        document.getElementById("activereembolsoy").classList.remove("btn-clicked-dps")
        document.getElementById("activereembolson").classList.remove("btn-clicked-dps")
        document.getElementById(id).classList.add("btn-clicked-dps")
      },
      changebtncolorresp(event){
        let id = event.currentTarget.id
        document.getElementById("resptitulary").classList.remove("btn-clicked-dps")
        document.getElementById("resptitularn").classList.remove("btn-clicked-dps")
        document.getElementById(id).classList.add("btn-clicked-dps")
      },
      gotofinalizar(flag){
        if (this.validaCadastro()){
          if (this.opcaoescolhida === 3) {
            const infoContaOpcionalCopy = JSON.parse(JSON.stringify(this.infocontaopcional))
            delete infoContaOpcionalCopy.habilitareembolso
            store.commit('mutAliancaInfoConta', infoContaOpcionalCopy)
          } else {
            store.commit('mutAliancaInfoConta', this.infoconta)
          }
          store.commit('mutAliancaObjInfoPagamento', {
            habilitareembolso: !this.contaOpcional,
            matriculaservidor: this.matriculaservidor,
            unidadepagadora: this.unidadepagadora,
            tipo_servidor: this.tipo_servidor,
            matriculaservidorpensionista: this.matriculaservidorpensionista,
            infocontaopcional: this.infocontaopcional,
            nomerespfinanceiro: this.nomerespfinanceiro,
            cpfrespfinanceiro: this.cpfrespfinanceiro,
            emailrespfinanceiro: this.emailrespfinanceiro,
            diasvencimento: this.diavencimento,
            flagtipoorgao: this.flagtipoorgao
          })
          store.commit('mutAliancaFormaPagamento', flag)
          document.getElementById('step-progress').value = 97.65
          this.$router.push("finalizar-proposta")
        }
      },
    },
    mounted(){
      document.getElementById('step-progress').value = 91.33
      document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
      document.getElementById('globaletapa2').classList.remove("etapas-progresso-texto-disabled")
      document.getElementById('globaletapa3').classList.remove("etapas-progresso-texto-disabled")

      document.getElementsByClassName('dados-beneficiario-tab-item')[0].classList.add("dados-beneficiario-tab-pagamento")

      const infoConta = store.getters.getAliancaInfoConta;
      
      this.infoconta = {
        banco: infoConta.banco ? infoConta.banco : null,
        agencia: infoConta.agencia ? infoConta.agencia : '',
        digitoag: infoConta.digitoag ? infoConta.digitoag : '',
        tipoconta: infoConta.tipoconta ? infoConta.tipoconta : null,
        conta: infoConta.conta ? infoConta.conta : '',
        digitoconta: infoConta.digitoconta ? infoConta.digitoconta : '',
      }

      const infoPagamento = store.getters.getAliancaObjInfoPagamento;

      this.infocontaopcional = {
        habilitareembolso: infoPagamento.infocontaopcional.habilitareembolso ? infoPagamento.infocontaopcional.habilitareembolso : false,
        banco: infoPagamento.infocontaopcional.banco ? infoPagamento.infocontaopcional.banco : null,
        agencia: infoPagamento.infocontaopcional.agencia ? infoPagamento.infocontaopcional.agencia : '',
        digitoag: infoPagamento.infocontaopcional.digitoag ? infoPagamento.infocontaopcional.digitoag : '',
        tipoconta: infoPagamento.infocontaopcional.tipoconta ? infoPagamento.infocontaopcional.tipoconta : null,
        conta: infoPagamento.infocontaopcional.conta ? infoPagamento.infocontaopcional.conta : '',
        digitoconta: infoPagamento.infocontaopcional.digitoconta ? infoPagamento.infocontaopcional.digitoconta : '',
        operacao: infoPagamento.infocontaopcional.operacao ? infoPagamento.infocontaopcional.operacao : null,
      }

      this.nomerespfinanceiro = infoPagamento.nomerespfinanceiro ? infoPagamento.nomerespfinanceiro : ''
      this.cpfrespfinanceiro = infoPagamento.cpfrespfinanceiro ? infoPagamento.cpfrespfinanceiro : ''
      this.emailrespfinanceiro = infoPagamento.emailrespfinanceiro ? infoPagamento.emailrespfinanceiro : ''
      this.matriculaservidor = infoPagamento.matriculaservidor ? infoPagamento.matriculaservidor : ''
      this.unidadepagadora = infoPagamento.unidadepagadora ? infoPagamento.unidadepagadora : null
      this.tipo_servidor = infoPagamento.tipo_servidor ? infoPagamento.tipo_servidor : null
      this.matriculaservidorpensionista = infoPagamento.matriculaservidorpensionista ? infoPagamento.matriculaservidorpensionista : ''

    },
    async created() {      
      let objdps = store.getters.getAliancaObjDPS
      if (objdps != null){

        let bodyreq = {
          nomeConvenio: "",
          nomeSubFat: "",
          codigoConvenio: store.getters.getAliancaNumeroContrato,
          codigoSubFat: store.getters.getAliancaSubFatura
        }
        let formasdepagamento = await obterFormasPagamento(bodyreq)
        this.diasvencimento = formasdepagamento[0].DIAS_VENCIMENTO.split(',')

        if (this.diasvencimento.length === 1) {
          this.diavencimento = this.diasvencimento[0]
        }

        if (this.diasvencimento.length === 1 ) {
          this.diavencimento = this.diasvencimento[0]
        }

        this.flagtipoorgao = formasdepagamento[0].TIPO_ORGAO

        let acccolumn = 0
        if ( formasdepagamento[0].DEBITO == 'S' ){
          this.exibedebito = true
          acccolumn++
        }
        if ( formasdepagamento[0].CONSIGNACAO == 'S' ){
          this.exibeconsignacao = true
          acccolumn++
        }
        if ( formasdepagamento[0].BOLETO == 'S' ){
          this.exibeboleto = true
          acccolumn++
        }

        this.colsystem = 12 / acccolumn

        let bancos = await listaBancos()
        for ( let i = 0; i < bancos.length; i++ ) this.listabancos.push({ value: bancos[i].A6_COD, text: bancos[i].A6_NOME })
        // listaBancos.lenght // this.listabancos.push({ value: listaBancos[i].value, text: listaBancos[i].text })

      let unidadepagadora = await unidadePagadora()
      for ( let i = 0; i < unidadepagadora.length; i++ ) this.options_unidadepagadora.push({ value: unidadepagadora[i].ZZL_CODIGO, name: unidadepagadora[i].ZZL_CODIGO + " - " +unidadepagadora[i].ZZL_DESCRI })

        this.isLoading = false
    } else {
      this.$router.push("declaracao-saude");
    }
  }
}
</script>
<style lang="scss">

.vencimento-wrapper {
  max-width: 680px;
  margin: 0 auto;
  padding-top: 30px;
  margin-top: 20px;
  border-top: 1px solid #E0E0E0;
  
  .btns-dia-vencimento {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .dia-vencimento {
      max-width: 148px;
      min-width: 125px;
      margin-bottom: 15px;
      width: unset;
    }
  }
}
</style>
